import React, { Component } from 'react';
import './index.scss';
//import { Container, Col, Row, InputGroup, FormControl} from 'react-bootstrap';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faCog, faTimesCircle, faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'

class Holder extends Component {
  constructor(props) {
    super(props)
      
    this.state = {
      show : false,
    }

  }

  componentDidMount() {

  }

  componentWillUpdate(props, state) {
    //console.log("D")
  }


  render() {
    return(
      <div className={["Holder"].join(' ')} >
        <div className={["Header"].join(' ')} onClick={ (e)=> {
          this.setState({
            show : !this.state.show,
          })
          this.props.updateValue({
            selectedSymbol : null
          })
        }}>
          { this.props.index+1 + ". " + this.props.obj.key + "[" + this.props.obj.value.length + "]" }
        </div>
        <div className={["Container", this.state.show?"Show":"Hide"].join(' ')}>
          <div className={["Record" , "Title"].join(' ')} >
              <div className={["Data"].join(' ')}> { "Rank" } </div>
              <div className={["Data"].join(' ')}> { "Symbol" } </div>
              <div className={["Data"].join(' ')}> { "Strength" } </div>
              <div className={["Data"].join(' ')}> { "VCP" } </div>
              <div className={["Data"].join(' ')}> { "MC" } </div>
          </div>
          {
            this.props.obj.value.map(
              (v2, k2) => {
                if( (v2.symbol === this.props.selectedSymbol) && !this.state.show  ) {
                  this.setState({
                    show : true
                  })
                }
                //if(  v2.near_high ) {
                //  console.log( "HIGH : " + v2.symbol )
                //}

                //if(  v2.near_low) {
                //  console.log( "LOW : " + v2.symbol )
                //}

                return (
                  <div className={["Record", (this.props.selectedSymbol===v2.symbol)?"Selected":""  ].join(' ')} key={k2}
                    onClick={
                      (e) => {
                        if( v2.symbol === this.props.selectedSymbol ) {
                          this.props.updateValue( {
                            selectedSymbol : null
                          } )
                        } else {
                          this.props.updateValue( {
                            selectedSymbol : v2.symbol
                          } )
                        }
                        //var sym = v2.symbol.replace( ".HK", "" )
                        //sym = parseInt( sym, 10 )
                        //console.log(sym)
                        //window.open( "http://www.aastocks.com/tc/stocks/quote/detailchart.aspx?symbol="+sym,  )
                      }
                      //http://www.aastocks.com/tc/stocks/quote/detailchart.aspx?symbol=14
                    }
                  >
                    <div
                      className={["Data", 
                        (v2.near_50d_high?"High50":""),
                        (v2.near_100d_high?"High100":""),
                        (v2.near_150d_high?"High150":""),
                        (v2.near_200d_high?"High200":""),
                        (v2.near_50d_low?"Low50":""),
                        (v2.near_100d_low?"Low100":""),
                        (v2.near_150d_low?"Low150":""),
                        (v2.near_200d_low?"Low200":"")
                      ].join(' ')}
                    > { k2+1} </div>
                    <div className={["Data"].join(' ')}> { v2.symbol } </div>
                    <div className={["Data", (v2.score > 70)?"green":((v2.score < 30)?"red":"") ].join(' ')}> { Math.round( v2.score * 100 )/100 } </div>
                    <div className={["Data", (v2.vcp > 70)?"green":((v2.vcp < 30)?"red":"")].join(' ')}> { Math.round( v2.vcp* 100 )/100 } </div>
                    <div className={["Data"].join(' ')}> { (Math.round( v2.marketcap* 100 )/100).toLocaleString("en-US") } </div>
                  </div>
                )
              }
            )
          }
        </div>
      </div>
    )
  }
}

export default Holder;

/*

*/